import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_REMINDER = 'GET_REMINDER';
export const GET_REMINDER_SUCCESS = 'GET_REMINDER_SUCCESS';
export const GET_REMINDER_FAILURE = 'GET_REMINDER_FAILURE';

// Action Creators
export const getReminder = () => ({
  type: GET_REMINDER,
});

export const getReminderSuccess = (users) => ({
  type: GET_REMINDER_SUCCESS,
  payload: users,
});

export const getReminderFailure = (error) => ({
  type: GET_REMINDER_FAILURE,
  payload: error,
});

// Thunk Function
export const getReminderCallAPI = (external) => {
  return async (dispatch) => {
    dispatch(getReminder());
    try {
      const response = await getMethodWithToken(url?.reminder);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getReminderSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getReminderFailure(error?.message));
    }
  };
};
